var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('markdown-it-vue',{staticClass:"md-body",attrs:{"content":_vm.content,"options":_vm.options}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }